import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import wiseneCardIconStyle from "./wiseneCardIconStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

function CardIcon({ ...props }) {
  const { classes, className, children, color, ...rest } = props;
  const CardIconClasses = classNames({
    [classes.cardIcon]: true,
    [classes[color + "CardHeader"]]: color,
    [className]: className !== undefined
  });
  return (
    <div className={CardIconClasses} {...rest}>
      {children}
    </div>
  );
}

CardIcon.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(["L0", "L1", "L2", "L3", "L4", "obstructed", "W2NonOperational", "inactive"])
};

export default withStyles(wiseneCardIconStyle)(CardIcon);
